import React from 'react';

function Navbar({ isLoggedIn, onNavigate, onLogout, currentPage }) {
  return (
    <nav className="navbar fixed-top" style={{boxShadow: '0 2px 8px rgba(0,0,0,0.07)', zIndex: 1050}}>
      <div className="navbar-brand" onClick={() => onNavigate('home')}>
        <div className="brand-logo" style={{display: 'flex', alignItems: 'center', gap: 8}}>
          <img src={process.env.PUBLIC_URL + '/neebunlogo.png'} alt="NeeBun Logo" style={{height: 36, width: 36, objectFit: 'contain', marginRight: 8}} />
          <span className="brand-name" style={{fontWeight: 700, fontSize: '1.4rem', letterSpacing: '1px'}}>NeeBun 
            {/* <span className="text-danger">By Red Chilly Computers</span> */}
            </span>
        </div>
      </div>

      <ul className="navbar-links">
        {!isLoggedIn && (
          <>
            <li>
              <button
                className={`nav-link ${currentPage === 'home' ? 'active' : ''}`}
                onClick={() => onNavigate('home')}
              >
                Home
              </button>
            </li>
            <li>
              <button
                className={`nav-link ${currentPage === 'blog' ? 'active' : ''}`}
                onClick={() => onNavigate('blog')}
              >
                Blog
              </button>
            </li>
            <li>
              <button
                className="nav-btn-login"
                onClick={() => onNavigate('login')}
              >
                Login
              </button>
            </li>
          </>
        )}

        {isLoggedIn && (
          <>
            <li>
              <button
                className={`nav-link ${currentPage === 'admin' ? 'active' : ''}`}
                onClick={() => onNavigate('admin')}
              >
                Admin Panel
              </button>
            </li>
            <li>
              <button className="nav-btn-logout" onClick={onLogout}>
                Logout
              </button>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
}

export default Navbar;
